<form [formGroup]="quoteForm" (ngSubmit)="saveQuote()" class="prev-invoice edit pt-0 d-block">
    <a (click)="changeTab.emit('all-quotes')" href="javascript:void(0)" id="closeNew"
        class="closePrvinvoice close-circle">
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="44" viewBox="0 0 42 44">
            <g fill="none" fill-rule="evenodd">
                <g fill="#343434">
                    <path
                        d="M23.475 21.309l7.512-7.623c.685-.695.685-1.817 0-2.511-.684-.695-1.79-.695-2.474 0L21 18.798l-7.513-7.623c-.684-.695-1.79-.695-2.474 0-.684.694-.684 1.816 0 2.51l7.513 7.624-7.513 7.623c-.684.694-.684 1.817 0 2.51.341.347.79.521 1.237.521.448 0 .896-.174 1.237-.52L21 23.82l7.513 7.623c.341.346.79.52 1.237.52.448 0 .896-.174 1.237-.52.685-.694.685-1.817 0-2.51l-7.512-7.624z"
                        transform="translate(-896 -298) translate(458 250) translate(438 48.706)" />
                </g>
            </g>
        </svg>
    </a>
    <div class="page-size" *ngIf="userInfo && quotation">
        <div class="prev-invoice__leftSection quotation-reciever-view__invoice">
            <div class="wrapper">
                <div class="logoArea">
                    <div class="logo-image">
                        <a *ngIf="userInfo.has_logo" href="javascript:void(0);">
                            <img src="{{ userInfo.logo }}" alt="logo" loading="lazy">
                        </a>
                    </div>
                </div>
                <div class="priceSection">
                    <span class="total-due" i18n="@@invoices.preview.total_amount_due"
                        [attr.style]="'color:'+prefTextColor | safe:'style'">TOTAL AMOUNT DUE</span>
                    <span class="amount text-dark">
                        <span class="sar" [innerHtml]="userInfo.currency_symbol"></span>
                        {{newQuoteTotal | number:'.2'}}
                    </span>
                </div>
            </div>

            <hr class="hr-row">

            <div class="wrapper">
                <div class="taxSection">
                    <span class="name">{{ quotation.client.full_name }}</span>
                    <span class="tax-no" *ngIf="quotation.user.tax_number">
                        <ng-container i18n="@@invoices.preview.tax_no">TIN:</ng-container> {{ quotation.user.tax_number ? quotation.user.tax_number : '-' }}
                    </span>
                </div>
                <div class="date-and-no">
                    <span class="number" [attr.style]="'color:'+prefTextColor | safe:'style'">#{{ quotation.quotation_number }}</span>
                    <span class="date">{{ quotation.quotation_date | date:'dd/MM/yyyy' }}</span>
                </div>
            </div>

            <hr class="hr-row">

            <div class="prev-invoice__tableSection">
                <div class="wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th class="item-title" [attr.style]="'color:'+prefTextColor | safe:'style'" i18n="@@invoices.preview.item_cap">ITEM</th>
                                <th class="item-rate" i18n="@@invoices.rate" [attr.style]="'color:'+prefTextColor | safe:'style'">RATE</th>
                                <th class="item-tax" i18n="@@invoices.tax" [attr.style]="'color:'+prefTextColor | safe:'style'" *ngIf="quotation.tax_percent"> VAT</th>
                                <th class="item-amount" [attr.style]="'color:'+prefTextColor | safe:'style'" i18n="@@invoices.preview.amount_cap">AMOUNT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container
                                *ngFor="let deliverable of deliverables?.controls; index as $index; first as isFirst">
                                <tr [formGroup]="deliverable">
                                    <td class="item-title">
                                        <div class="td-wrapper">
                                            <span class="count-num">
                                                <input type="number" appPreventScroll name="quantity" formControlName="quantity" [ngClass]="{'error': deliverable.get('quantity').invalid }" placeholder="0" autocomplete="off">
                                            </span>
                                            <input type="text" name="title" formControlName="title" [ngClass]="{'error': deliverable.get('title').invalid }" i18n-placeholder="@@placeholder.type_here" placeholder="Type Here" autocomplete="off">
                                        </div>
                                    </td>
                                    <td class="item-rate">
                                        <input type="number" name="rate" formControlName="rate" [ngClass]="{'error': deliverable.get('rate').invalid }"placeholder="{{'0.00'}}" autocomplete="off">
                                    </td>
                                    <td class="item-tax" *ngIf="quoteForm.get('include_tax').value">
                                        <fieldset>
                                            <input class="styled-checkbox" id="item-tax-{{$index}}" [formControl]="deliverable.controls.is_taxable" name="is_taxable" type="checkbox" disabled>
                                            <label for="item-tax-{{$index}}"></label>
                                        </fieldset>
                                    </td>
                                    <td class="item-amount">
                                        <span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span>
                                        <span class="amount-input">
                                            <input type="text" name="title" [value]="(getItemSubTotal(deliverable.value) | number:'.2')" readonly>
                                        </span>
                                        <div class="invoice-edit-control">
                                            <a class="cross" href="javascript:void(0)"
                                                (click)='removeDeliverable($index)'>
                                                <svg version="1.1" x="0px" y="0px" width="12" height="12" viewBox="0 0 14 14">
                                                    <path fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
                                                </svg>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>

                            <tr [formGroup]="deliverableForm"
                                (keydown)="$event.keyCode == 13 ? addDeliverable(deliverableForm) : true">
                                <td class="item-title">
                                    <div class="td-wrapper">
                                        <span class="count-num">
                                            <input type="number" appPreventScroll name="quantity" formControlName="quantity" [ngClass]="{'error': deliverableForm.get('submitted').value && deliverableForm.get('quantity').invalid }" placeholder="0" autocomplete="off">
                                        </span>
                                        <input type="text" name="title" formControlName="title" [ngClass]="{'error': deliverableForm.get('submitted').value && deliverableForm.get('title').invalid }" i18n-placeholder="@@placeholder.type_here" placeholder="Type Here" autocomplete="off">
                                    </div>
                                </td>
                                <td class="item-rate">
                                    <input type="number" appPreventScroll name="rate" formControlName="rate" [ngClass]="{'error': deliverableForm.get('submitted').value && deliverableForm.get('rate').invalid }" placeholder="{{ '0.00' }}" autocomplete="off">
                                </td>
                                <td class="item-tax" *ngIf="quoteForm.get('include_tax').value">
                                    <fieldset>
                                        <input class="styled-checkbox" id="item-tax-new" [formControl]="deliverableForm.controls.is_taxable" name="is_taxable" type="checkbox" disabled>
                                        <label for="item-tax-new"></label>
                                    </fieldset>
                                </td>
                                <td class="item-amount">
                                    <span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span>
                                    <span class="amount-input">
                                        <input type="text" name="title" [value]="(getItemSubTotal(deliverableForm.value) | number:'.2')" readonly>
                                    </span>
                                    <div class="invoice-edit-control">
                                        <a href="javascript:void(0)" (click)="addDeliverable(deliverableForm)" class="tu-btn-circular pink">
                                            <svg width="14" height="14" viewBox="0 0 14 14">
                                                <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
                                                    <path d="M1 7h12M7 1v12" />
                                                </g>
                                            </svg>
                                        </a>
                                    </div>
                                </td>
                            </tr>

                            <tr class="dashed-border" *ngIf="taxAmount">
                                <td class="item-title py-2">
                                    <ng-container i18n="@@tax">VAT</ng-container>({{ quotation.tax_percent }}%)
                                </td>
                                <td class="item-rate"></td>
                                <td class="item-tax" *ngIf="quotation.tax_percent"></td>
                                <td class="item-amount py-2">
                                    <span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span>
                                    {{ newDeliverableTax | number:'1.0-2' }} 
                                </td>
                            </tr>

                            <tr>
                                <td class="item-title py-2">
                                    <div class="td-wrapper align-items-center">
                                        <span class="vat-percentage pr-2 min-w-130">
                                            <label i18n="@@invoices.discount" for="discount">Discount</label>
                                        </span>
                                        <fieldset  [ngClass]="{'has-error':quoteForm.controls.discount.errors}">
                                             <div class="tag-input-discount">
                                                <span class="field-error" *ngIf="quoteForm.controls.discount.errors?.min" i18n="@@error.invalid_discount">Please enter valid discount (1-100)</span>	
                                                <span class="field-error" *ngIf="quoteForm.controls.discount.errors?.max" i18n="@@error.invalid_discount">Please enter valid discount (1-100)</span>	
                                               <input type="number" appPreventScroll formControlName="discount" (ngModelChange)="changeDiscount($event)" placeholder="0%"/>
                                             </div>
                                       </fieldset>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td class="item-title py-2">
                                    <div class="td-wrapper align-items-center">
                                        <span class="vat-percentage pr-2 min-w-130">
                                            <label i18n="@@invoices.delivery_fee" for="delivery_fee">Delivery Fees</label>
                                        </span>
                                        <fieldset  [ngClass]="{'has-error':quoteForm.controls.delivery_fee.errors}">
                                             <div class="tag-input-discount">
                                               <input type="number" appPreventScroll formControlName="delivery_fee" placeholder="0" />
                                             </div>
                                       </fieldset>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div class="wrapper">
                <div class="prev-invoice__totalSection pt-2">
                    <ul>
                        <li *ngIf="newSubTotalDeliverableCost != null">
                            <span class="totalAmount" i18n="@@invoices.total">Total</span>
                            <span class="totalRate text-dark" [attr.style]="'color:'+prefTextColor | safe:'style'">
                                <span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span>
                                {{ newSubTotalDeliverableCost | number:'.2' }}
                            </span>
                        </li>

                        <li *ngIf="newQuoteDiscountAmount != null">
                            <span class="totalAmount" i18n="@@invoices.discount">Discount ({{ quotation.discount }}%)</span>
                            <span class="totalRate text-dark" [attr.style]="'color:'+prefTextColor | safe:'style'">
                                <span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span>
                                {{ newQuoteDiscountAmount | number:'.2' }}
                            </span>
                        </li>

                        <li *ngIf="newQuoteDeliveryFeeAmount != null">
                            <span class="totalAmount" i18n="@@invoices.delivery_fees">Delivery Fees</span>
                            <span class="totalRate text-dark" [attr.style]="'color:'+prefTextColor | safe:'style'">
                                <span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span>
                                {{ newQuoteDeliveryFeeAmount | number:'.2' }}
                            </span>
                        </li>

                        <li>
                            <span class="totalAmount" i18n="@@invoices.preview.total_amount">Total Amount</span>
                            <span class="totalRate text-dark" [attr.style]="'color:'+prefTextColor | safe:'style'">
                                <span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span>
                                {{ newQuoteTotal | number:'.2' }}
                            </span>
                        </li>
                        <!-- <li>
                            <span class="totalAmount" i18n="@@invoices.preview.total_amount_due">Total Amount Due</span>
                            <span class="totalRate text-dark">{{ quoteTotal | number:'.2' }}<span class="sar-cur">{{
                                    userInfo.currency_symbol }}</span></span>
                        </li>
                        <li>
                        <span class="totalAmount" i18n="@@invoices.amount_paid">Amount Paid</span>
                        <span class="totalRate" [attr.style]="'color:'+prefTextColor | safe:'style'">{{ quotation.paid_amount | number:'.2'  }}<span class="sar-cur">{{ userInfo.currency_symbol }}</span></span>
                    </li>
                    <li>
                        <span class="totalAmount" i18n="@@invoices.amount_due">Amount Due</span>
                        <span class="totalRate" [attr.style]="'color:'+prefTextColor | safe:'style'">{{ (quoteTotal - quotation.paid_amount) | number:'.2' }}<span class="sar-cur">{{ userInfo.currency_symbol }}</span></span>
                    </li>-->
                    </ul>
                </div>
            </div>

            <div class="wrapper" *ngIf="quotation.additional_info">
				<div class="quotation-reciever-view-additionalInfo">
					<div class="quotation-reciever-view-additionalInfo__header" >
							<p i18n="@@invoices.additional_info">Additional Information</p>
							<div></div>
					</div>
					<div class="quotation-reciever-view-additionalInfo__body">
						<p class="pre-text" [innerHTML]="quotation.additional_info"></p>
					</div>
				</div>
			</div>

            <div class="wrapper" *ngIf="quotation.reason">
				<div class="quotation-reciever-view-additionalInfo">
					<div class="quotation-reciever-view-additionalInfo__header" >
							<p i18n="@@quotation.rejection_reason">Rejection Reason</p>
							<div></div>
					</div>
					<div class="quotation-reciever-view-additionalInfo__body">
						<p class="pre-text" [innerHTML]="quotation.reason"></p>
					</div>
				</div>
			</div>
        </div>

        <div class="prev-invoice__rightSection">
            
        </div>
    </div>


    <div class="prev-invoice__bottomInfo">
		<div class="social-wrapper align-items-center">
			<span i18n="@@quotation.send_quotation_via">Send quotation via</span>

			<a href="javascript:void(0)" (click)="saveAndEmail()" *ngIf="quotation.client_has_email">
				<svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18">
					<g fill="none" fill-rule="evenodd">
						<g fill="#1C6AB6">
							<path
								d="M17.82 17.144H3.146c-.578 0-1.048-.465-1.048-1.038V5.992l7.757 5.757c.186.14.408.208.629.208.22 0 .442-.069.629-.208l7.757-5.757v10.114c0 .573-.47 1.038-1.048 1.038zm-.699-12.449l-6.638 4.928-6.639-4.928h13.277zm.7-2.074H3.145C1.41 2.62 0 4.017 0 5.733v10.373c0 1.716 1.411 3.112 3.145 3.112H17.82c1.734 0 3.145-1.396 3.145-3.112V5.733c0-1.716-1.411-3.112-3.145-3.112z"
								transform="translate(-365 -923) translate(0 849) translate(348 55) translate(17 17)" />
						</g>
					</g>
				</svg>
			</a>

			<a href="javascript:void(0)" (click)="saveAsPdf()">
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21">
					<g fill="none" fill-rule="evenodd">
						<path fill="#1C6AB6"
							d="M9.721 3.905c-.007 0-.021.001-.044.01-.103.033-.208.188-.28.412-.22.672-.133 1.802.323 2.843.145-.493.232-.908.255-1.223.111-1.536-.137-1.933-.217-2.017-.022-.025-.03-.025-.037-.025m.244 5.293c-.319.783-.707 1.63-1.128 2.462a18.051 18.051 0 0 1 2.54-.431l.213-.02a58.897 58.897 0 0 1-1.238-1.524l-.387-.487m3.664 2.852c.688.638 1.266.996 1.754 1.085.11.02.22.031.325.031.36 0 .598-.123.664-.239.013-.02.03-.05-.011-.121-.154-.265-.9-.701-2.732-.756m-6.743 1.254c-.637.308-1.163.663-1.572 1.063-.804.785-.856 1.278-.812 1.388.014.032.07.039.114.039.136 0 .319-.069.5-.186.397-.26 1.053-1.121 1.77-2.304m-2.27 3.402c-.446 0-.804-.227-.959-.607-.257-.632.114-1.501 1.02-2.386.708-.692 1.698-1.261 2.943-1.695a32.176 32.176 0 0 0 1.699-3.67c-.946-1.471-1.121-3.289-.79-4.304.214-.657.585-.904.858-.995a.965.965 0 0 1 1.04.259c.409.439.559 1.323.458 2.704-.039.55-.222 1.289-.544 2.2l.043.052c.214.263.443.551.684.854.512.646 1.087 1.371 1.673 2.021.173-.005.339-.007.5-.007 2.068 0 3.457.432 3.91 1.218.194.334.198.711.012 1.034-.252.435-.795.695-1.455.695-.16 0-.324-.015-.49-.047-.832-.153-1.744-.778-2.861-1.963-.286.016-.585.038-.892.068-.658.064-1.93.23-3.215.634-.555 1-1.746 3.02-2.634 3.6-.337.22-.682.335-1 .335">
						</path>
						<path stroke="#1C6AB6" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
							d="M18.86 19.549l-17.77.086L1 1.02 18.8 1z"></path>
					</g>
				</svg>
			</a>

			<a href="javascript:void(0)" (click)="saveAndWhatsapp()">
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="2489" height="2500"
					viewBox="0 0 1219.547 1225.016">
					<path fill="#E0E0E0"
						d="M1041.858 178.02C927.206 63.289 774.753.07 612.325 0 277.617 0 5.232 272.298 5.098 606.991c-.039 106.986 27.915 211.42 81.048 303.476L0 1225.016l321.898-84.406c88.689 48.368 188.547 73.855 290.166 73.896h.258.003c334.654 0 607.08-272.346 607.222-607.023.056-162.208-63.052-314.724-177.689-429.463zm-429.533 933.963h-.197c-90.578-.048-179.402-24.366-256.878-70.339l-18.438-10.93-191.021 50.083 51-186.176-12.013-19.087c-50.525-80.336-77.198-173.175-77.16-268.504.111-278.186 226.507-504.503 504.898-504.503 134.812.056 261.519 52.604 356.814 147.965 95.289 95.36 147.728 222.128 147.688 356.948-.118 278.195-226.522 504.543-504.693 504.543z" />
					<linearGradient id="a" gradientUnits="userSpaceOnUse" x1="609.77" y1="1190.114" x2="609.77" y2="21.084">
						<stop offset="0" stop-color="#20b038" />
						<stop offset="1" stop-color="#60d66a" />
					</linearGradient>
					<path fill="url(#a)"
						d="M27.875 1190.114l82.211-300.18c-50.719-87.852-77.391-187.523-77.359-289.602.133-319.398 260.078-579.25 579.469-579.25 155.016.07 300.508 60.398 409.898 169.891 109.414 109.492 169.633 255.031 169.57 409.812-.133 319.406-260.094 579.281-579.445 579.281-.023 0 .016 0 0 0h-.258c-96.977-.031-192.266-24.375-276.898-70.5l-307.188 80.548z" />
					<image overflow="visible" opacity=".08" width="682" height="639" xlink:href="FCC0802E2AF8A915.png"
						transform="translate(270.984 291.372)" />
					<path fill-rule="evenodd" clip-rule="evenodd" fill="#FFF"
						d="M462.273 349.294c-11.234-24.977-23.062-25.477-33.75-25.914-8.742-.375-18.75-.352-28.742-.352-10 0-26.25 3.758-39.992 18.766-13.75 15.008-52.5 51.289-52.5 125.078 0 73.797 53.75 145.102 61.242 155.117 7.5 10 103.758 166.266 256.203 226.383 126.695 49.961 152.477 40.023 179.977 37.523s88.734-36.273 101.234-71.297c12.5-35.016 12.5-65.031 8.75-71.305-3.75-6.25-13.75-10-28.75-17.5s-88.734-43.789-102.484-48.789-23.75-7.5-33.75 7.516c-10 15-38.727 48.773-47.477 58.773-8.75 10.023-17.5 11.273-32.5 3.773-15-7.523-63.305-23.344-120.609-74.438-44.586-39.75-74.688-88.844-83.438-103.859-8.75-15-.938-23.125 6.586-30.602 6.734-6.719 15-17.508 22.5-26.266 7.484-8.758 9.984-15.008 14.984-25.008 5-10.016 2.5-18.773-1.25-26.273s-32.898-81.67-46.234-111.326z" />
					<path fill="#FFF"
						d="M1036.898 176.091C923.562 62.677 772.859.185 612.297.114 281.43.114 12.172 269.286 12.039 600.137 12 705.896 39.633 809.13 92.156 900.13L7 1211.067l318.203-83.438c87.672 47.812 186.383 73.008 286.836 73.047h.255.003c330.812 0 600.109-269.219 600.25-600.055.055-160.343-62.328-311.108-175.649-424.53zm-424.601 923.242h-.195c-89.539-.047-177.344-24.086-253.93-69.531l-18.227-10.805-188.828 49.508 50.414-184.039-11.875-18.867c-49.945-79.414-76.312-171.188-76.273-265.422.109-274.992 223.906-498.711 499.102-498.711 133.266.055 258.516 52 352.719 146.266 94.195 94.266 146.031 219.578 145.992 352.852-.118 274.999-223.923 498.749-498.899 498.749z" />
				</svg>
			</a>

            <a (click)="saveQuote()" href="javascript:void(0);" placement="top" i18n-ngbTooltip="@@invoices.save_invoice" tooltipClass="link-tooltip" ngbTooltip="Save Invoice">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <g fill="none" fill-rule="evenodd" stroke="#1C6AB6" stroke-linecap="square" stroke-width="1.5">
                        <path d="M4.6 15.4V10h10.8v5.4" />
                        <path d="M17.2 19H2.8A1.8 1.8 0 0 1 1 17.2V2.8A1.8 1.8 0 0 1 2.8 1h11.7L19 5.5v11.7a1.8 1.8 0 0 1-1.8 1.8zM12.7 4.6v1.8" />
                    </g>
                </svg>
            </a>
            <a *ngIf="!quotation.sub_total" (click)="saveAsDraft()" placement="top" i18n-ngbTooltip="@@invoices.save_as_draft" tooltipClass="link-tooltip" ngbTooltip="Save as Draft">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22">
                    <g fill="none" fill-rule="evenodd" stroke="#1C6AB6" stroke-linecap="round"
                        stroke-linejoin="round" stroke-width="1.5">
                        <path d="M16.9 21.024L1.106 21.1 1 1.46l10.154-.05 5.668 5.921z" />
                        <path d="M16.642 7.165h-5.538V1.42M12.78 10.97L8.21 15.544 5.78 13.115" />
                    </g>
                </svg>
            </a>
		</div>
	</div>

    <!-- <div class="new-invoice__bottom-section">
        <div class="create-invoice__btnWrap">
            <div class="left-links">
                <a (click)="saveAsPdf()" href="javascript:void(0);" class="tu-btn tu-link icon-color" placement="top"
                    i18n-ngbTooltip="@@button.save_as_pdf" tooltipClass="link-tooltip" ngbTooltip="Save as PDF">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21">
                        <g fill="none" fill-rule="evenodd">
                            <path fill="#1C6AB6"
                                d="M9.721 3.905c-.007 0-.021.001-.044.01-.103.033-.208.188-.28.412-.22.672-.133 1.802.323 2.843.145-.493.232-.908.255-1.223.111-1.536-.137-1.933-.217-2.017-.022-.025-.03-.025-.037-.025m.244 5.293c-.319.783-.707 1.63-1.128 2.462a18.051 18.051 0 0 1 2.54-.431l.213-.02a58.897 58.897 0 0 1-1.238-1.524l-.387-.487m3.664 2.852c.688.638 1.266.996 1.754 1.085.11.02.22.031.325.031.36 0 .598-.123.664-.239.013-.02.03-.05-.011-.121-.154-.265-.9-.701-2.732-.756m-6.743 1.254c-.637.308-1.163.663-1.572 1.063-.804.785-.856 1.278-.812 1.388.014.032.07.039.114.039.136 0 .319-.069.5-.186.397-.26 1.053-1.121 1.77-2.304m-2.27 3.402c-.446 0-.804-.227-.959-.607-.257-.632.114-1.501 1.02-2.386.708-.692 1.698-1.261 2.943-1.695a32.176 32.176 0 0 0 1.699-3.67c-.946-1.471-1.121-3.289-.79-4.304.214-.657.585-.904.858-.995a.965.965 0 0 1 1.04.259c.409.439.559 1.323.458 2.704-.039.55-.222 1.289-.544 2.2l.043.052c.214.263.443.551.684.854.512.646 1.087 1.371 1.673 2.021.173-.005.339-.007.5-.007 2.068 0 3.457.432 3.91 1.218.194.334.198.711.012 1.034-.252.435-.795.695-1.455.695-.16 0-.324-.015-.49-.047-.832-.153-1.744-.778-2.861-1.963-.286.016-.585.038-.892.068-.658.064-1.93.23-3.215.634-.555 1-1.746 3.02-2.634 3.6-.337.22-.682.335-1 .335" />
                            <path stroke="#1C6AB6" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                d="M18.86 19.549l-17.77.086L1 1.02 18.8 1z" />
                        </g>
                    </svg>
                </a>
                <a (click)="saveQuote()" href="javascript:void(0);" class="tu-btn tu-link icon-color" placement="top"
                    i18n-ngbTooltip="@@invoices.save_invoice" tooltipClass="link-tooltip" ngbTooltip="Save Invoice">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <g fill="none" fill-rule="evenodd" stroke="#1C6AB6" stroke-linecap="square" stroke-width="1.5">
                            <path d="M4.6 15.4V10h10.8v5.4" />
                            <path
                                d="M17.2 19H2.8A1.8 1.8 0 0 1 1 17.2V2.8A1.8 1.8 0 0 1 2.8 1h11.7L19 5.5v11.7a1.8 1.8 0 0 1-1.8 1.8zM12.7 4.6v1.8" />
                        </g>
                    </svg>
                </a>
                <a *ngIf="!quotation.sub_total" (click)="saveAsDraft()" class="tu-btn tu-link icon-color"
                    placement="top" i18n-ngbTooltip="@@invoices.save_as_draft" tooltipClass="link-tooltip"
                    ngbTooltip="Save as Draft">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22">
                        <g fill="none" fill-rule="evenodd" stroke="#1C6AB6" stroke-linecap="round"
                            stroke-linejoin="round" stroke-width="1.5">
                            <path d="M16.9 21.024L1.106 21.1 1 1.46l10.154-.05 5.668 5.921z" />
                            <path d="M16.642 7.165h-5.538V1.42M12.78 10.97L8.21 15.544 5.78 13.115" />
                        </g>
                    </svg>
                </a>
                <a (click)="openPreviewModal()" href="javascript:void(0)"  class="tu-btn tu-link icon-color link-tooltip" data-toggle="tooltip" data-placement="top" i18n-title="@@title.preview_invoice" title="Preview Invoice">
                  <span data-toggle="modal" data-target="#previewInvoice">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17">
                          <g fill="none" fill-rule="evenodd" stroke="#1C6AB6" stroke-linecap="square" stroke-width="1.5" transform="translate(1 1)">
                              <path d="M.3 8.2a1.42 1.42 0 0 1-.006-1.738C1.776 4.52 5.784 0 11 0c5.148 0 9.193 4.516 10.696 6.46.4.514.4 1.233 0 1.746-1.503 1.945-5.548 6.46-10.696 6.46S1.799 10.142.3 8.2z"/>
                              <circle cx="11" cy="7.333" r="4.4"/>
                          </g>
                      </svg>
                  </span>
              </a> -->
                <!-- <a (click)="deleteInvoice()" href="javascript:void(0);" class="tu-btn tu-link trash-icon link-tooltip" data-toggle="tooltip" data-placement="top" i18n-title="@@invoices.delete_invoice" title="Delete Invoice" *ngIf="!quotation.paid_amount">
                  <svg width="30" height="20" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                      <g >
                          <path d="M437.885,81.874h-71.646v-58.91C366.239,10.282,355.957,0,343.275,0H168.725c-12.682,0-22.964,10.282-22.964,22.964
                              v58.91H74.115c-12.682,0-22.964,10.282-22.964,22.964c0,12.682,10.282,22.964,22.964,22.964h2.794v361.233
                              c0,12.682,10.282,22.964,22.964,22.964h312.253c12.682,0,22.964-10.282,22.964-22.964V127.803h2.794
                              c12.682,0,22.964-10.282,22.964-22.964S450.567,81.874,437.885,81.874z M320.309,45.929v35.945H191.69V45.929H320.309z
                              M389.162,466.071H122.838V127.803h266.324V466.071z"/>
                          <path d="M184.044,413.979c12.682,0,22.964-10.282,22.964-22.964V224.373c0-12.682-10.282-22.964-22.964-22.964
                              c-12.682,0-22.964,10.282-22.964,22.964v166.642C161.08,403.697,171.362,413.979,184.044,413.979z"/>
                          <path d="M255.999,413.979c12.683,0,22.964-10.282,22.964-22.964V224.373c0-12.682-10.282-22.964-22.964-22.964
                              c-12.682,0-22.964,10.282-22.964,22.964v166.642C233.035,403.697,243.317,413.979,255.999,413.979z"/>
                          <path d="M327.954,413.979c12.682,0,22.964-10.282,22.964-22.964V224.373c0-12.682-10.282-22.964-22.964-22.964
                              s-22.964,10.282-22.964,22.964v166.642C304.99,403.697,315.272,413.979,327.954,413.979z"/>
                      </g>
                  </svg>
              </a>
            </div>
            <div class="right-btns">
                <button (click)="saveAndEmail()" type="button" class="tu-btn icon-left transparent mr-1"
                    *ngIf="quotation.client_has_email">
                    <svg width="20" height="16" viewBox="0 0 20 16">
                        <path class="icon-path" fill-rule="evenodd"
                            d="M0 16h20V0H0v16zM2.427 1.333h15.146L10 7.16 2.427 1.333zm16.24.841v12.493H1.334V2.174L10 8.841l8.667-6.667z" />
                    </svg>
                    <ng-container i18n="@@common.email">Email</ng-container>
                </button>
                <button (click)="saveAndWhatsapp()" type="button" class="tu-btn icon-left transparent whatsapp">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 478.165 478.165">
                        <g>
                            <path id="WhatsApp" class="icon-path whatsapp" d="M478.165,232.946c0,128.567-105.057,232.966-234.679,232.966c-41.102,0-79.814-10.599-113.445-28.969
                              L0,478.165l42.437-125.04c-21.438-35.065-33.77-76.207-33.77-120.159C8.667,104.34,113.763,0,243.485,0
                              C373.108,0,478.165,104.34,478.165,232.946z M243.485,37.098c-108.802,0-197.422,87.803-197.422,195.868
                              c0,42.915,13.986,82.603,37.576,114.879l-24.586,72.542l75.849-23.968c31.121,20.481,68.457,32.296,108.583,32.296
                              c108.723,0,197.323-87.843,197.323-195.908C440.808,124.921,352.208,37.098,243.485,37.098z M361.931,286.62
                              c-1.395-2.331-5.22-3.746-10.898-6.814c-5.917-2.849-34.089-16.497-39.508-18.37c-5.16-1.913-8.986-2.849-12.811,2.829
                              c-4.005,5.638-14.903,18.629-18.23,22.354c-3.546,3.785-6.854,4.264-12.552,1.435c-5.618-2.809-24.267-8.866-46.203-28.391
                              c-17.055-15.042-28.67-33.711-31.997-39.508c-3.427-5.758-0.398-8.826,2.471-11.635c2.69-2.59,5.778-6.734,8.627-10.041
                              c2.969-3.287,3.905-5.638,5.798-9.424c1.913-3.905,0.936-7.192-0.478-10.141c-1.415-2.849-13.01-30.881-17.752-42.337
                              c-4.841-11.416-9.543-9.523-12.871-9.523c-3.467,0-7.212-0.478-11.117-0.478c-3.785,0-10.041,1.395-15.381,7.192
                              c-5.2,5.658-20.123,19.465-20.123,47.597c0,28.052,20.601,55.308,23.55,59.053c2.869,3.785,39.747,63.197,98.303,86.07
                              c58.476,22.872,58.476,15.321,69.115,14.365c10.38-0.956,34.069-13.867,38.811-27.096
                              C363.345,300.307,363.345,288.991,361.931,286.62z" />
                        </g>
                    </svg>
                    Whatsapp
                </button>
            </div>
        </div>
    </div> -->
</form>